var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['c-loading-base-container', _vm.overly && 'overly']},[_c('div',{staticClass:"c-loading-base",style:(_vm.getStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }